import { render, staticRenderFns } from "./shogiCell.vue?vue&type=template&id=51d54ccd&scoped=true&"
import script from "./shogiCell.vue?vue&type=script&lang=js&"
export * from "./shogiCell.vue?vue&type=script&lang=js&"
import style0 from "./shogiCell.vue?vue&type=style&index=0&id=51d54ccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d54ccd",
  null
  
)

export default component.exports